import ContactLink from "../components/ContactLink";

const Footer = () => {
  return (
    <footer className="p-4 py-6 bg-btn-purple">
      <div
        className="container m-auto flex flex-col items-center justify-end"
        style={{ minHeight: "100px" }}
      >
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 items-center lg:items-end justify-center lg:justify-between w-full">
          <p className="text-white text-base">© 2024 Sapioo, Inc.</p>
          <a
            href="https://maps.app.goo.gl/BYDPjxKLLv76FTMJ8"
            target="_blank"
            rel="noreferrer"
            className="text-white text-base"
          >
            32/34 Gogebashvili str. Tbilisi, Georgia.
          </a>
          <p className="text-white text-base">+995595803343</p>
          <ContactLink
            styles="text-white text-base"
            text="Sapioo.info@gmail.com"
          />
        </div>
      </div>
    </footer>
  );
};
export default Footer;
